export const getIsNonEmptyArray = <Element>(
  array: Element[],
): array is Element[] & [Element] => array.length > 0
